// import React, { useEffect, useState } from 'react';
// import styles from './sidefilter.module.scss';
// import { ERCText } from 'components/text';
// import { Checkbox, colors } from '@mui/material';

// const SideFilter = ({ title, number, name, viewAll, onChange = () => null, defaultValue, data = [] }) => {
//   const [selected, setSelected] = useState({ name, value: defaultValue });

//   const selectItem = (item) => {
//     setSelected((prev) => ({
//       name,
//       value: item === prev.value ? null : item, // Toggle selection
//     }));
//   };

//   useEffect(() => {
//     onChange(selected);
//   }, [selected, onChange]); // Ensure `onChange` is included as a dependency

//   return (
//     <div className={styles.body}>
//       <div className={styles.header}>
//         <ERCText size="16px" weight="700" lHeight="24px">
//           {title}
//         </ERCText>
//         {viewAll && (
//           <ERCText size="12px" weight="600" lHeight="18px">
//             View All
//           </ERCText>
//         )}
//       </div>

//       <div className={styles.content}>
//         {data.length ? (
//           data.map((item, index) => (
//             <div
//               key={index} // Add key attribute here
//               className={styles.coursename}
//               onClick={() => selectItem(item)}
//             >
//               {/* Update Checkbox state and styles */}
//               <Checkbox
//                 checked={item === selected.value}
//                 style={{color:'blue'}}
//               />
//               <div className={styles.classtypes}>
//                 <ERCText size="16px" weight="400" lHeight="24px">
//                   {item}
//                 </ERCText>
//                 {number && (
//                   <ERCText size="16px" weight="400" lHeight="24px">
//                     ({number})
//                   </ERCText>
//                 )}
//               </div>
//             </div>
//           ))
//         ) : (
//           <ERCText size="14px" weight="600" color={colors.red[400]}>
//             Empty
//           </ERCText>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SideFilter;
import React, { useEffect, useState } from 'react';

const SideFilter = ({
  title,
  number,
  name,
  viewAll,
  onChange = () => null,
  defaultValue,
  data = []
}) => {
  const [selected, setSelected] = useState({ name, value: defaultValue });

  const selectItem = (e) => {
    setSelected({ name, value: e?.value === selected?.value ? null : e?.value });
  };

  useEffect(() => {
    onChange(selected);
  }, [selected, defaultValue]);

  return (
    <div className="p-4  rounded-lg ">
      <div className="flex justify-between items-center mb-4">
        <p className="text-lg font-bold">{title}</p>
        {viewAll && (
          <p className="text-sm font-semibold text-blue-500 cursor-pointer hover:underline">
            View All
          </p>
        )}
      </div>
      <div className="space-y-2">
        {data?.length ? (
          data.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between cursor-pointer hover:bg-gray-100 p-2 rounded"
              onClick={() => selectItem({ name, value: item })}
            >
              <div className="flex items-center">
                {/* Updated input check */}
                <input
                  type="checkbox"
                  className="checkbox form-checkbox h-4 w-4 text-red-500 border-gray-300 rounded focus:ring-blue-300 mr-2"
                  checked={item === selected?.value}
                  onChange={() => selectItem({ name, value: item })}
                />
                <p className="text-base font-normal">{item}</p>
              </div>
              {number && <p className="text-base text-gray-500">({number})</p>}
            </div>
          ))
        ) : (
          <p className="text-sm text-red-500">Empty</p>
        )}
      </div>
    </div>
  );
};

export default SideFilter;

